"use client"

import { useState } from "react";
import EyeOn from "@/components/icons/eye-on.svg";
import EyeOff from "@/components/icons/eye-off.svg";
import Key from "@/components/icons/key.svg";

interface PasswordFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  label?: string;
  onKeyUp?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  className?: string;
}

export default function PasswordField(props: PasswordFieldProps) {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <label className="input w-full">
      <Key height={14} width={14} className={"w-4 h-4 fill-base-content" + props.className ? ` ${props.className}` : ''} />
      <input
        className="grow"
        type={showPassword ? "text" : "password"}
        placeholder={props.placeholder}
        value={props.value}
        onChange={(e) => props.onChange(e.target.value)}
        onKeyUp={props.onKeyUp}
      />
      <button className="btn btn-ghost w-5 h-5 p-0 m-0" onClick={togglePasswordVisibility}>
        {showPassword ? (
          <EyeOff className="stroke-base-content/80" height={20} width={20} />
        ) : (
          <EyeOn className="stroke-base-content/80" height={20} width={20} />
        )}
      </button>
    </label>
  );
}
